import React, { FC } from "react";
import { makeStyles, styled } from "@material-ui/core/styles";
import Logo from "../../../../../images/logo-all-white-side.png";
import { SOCIAL_MEDIAS } from "./socialMedias";
import { SECTIONS } from "./sections";

const useStyles = makeStyles((theme) => ({
  footer: {
    position: "relative",
    backgroundColor: "#1f4ca0",
    paddingBottom: 16,
    "& section": {
      padding: 16,
      display: "flex",
      flexDirection: "column",
    },
    [theme.breakpoints.up("md")]: {
      "& section": {
        flexDirection: "row",
        alignItems: "center",
        padding: "80px 24px 24px",
        gap: 40,
      },
    },
  },
  social: {
    position: "absolute",
    top: 32,
    right: 16,
    display: "flex",
    alignItems: "center",
    "& span": {
      display: "none",
      color: "white",
      fontSize: 12,
      fontWeight: 500,
    },
    "& a": {
      width: 28,
      height: 28,
      fontSize: 18,
      color: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
    },
    [theme.breakpoints.up("sm")]: {
      "& span": {
        display: "block",
        marginRight: 12,
      },
    },
    [theme.breakpoints.up("md")]: {
      right: 48,
    },
  },
  logo: {
    "& img": {
      maxWidth: 160,
    },
    [theme.breakpoints.up("md")]: {
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        height: "fit-content",
        maxWidth: 220,
      },
    },
  },
  sections: {
    display: "grid",
    gap: 20,
    gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
    margin: 16,
    "& div": {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      color: "white",
      gap: 8,
      "& p": {
        fontSize: 16,
        textTransform: "uppercase",
        fontWeight: 600,
        lineHeight: "16px",
      },
      "& section": {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 6,
        margin: "2px 0",
        padding: "0 0 0 6px",
      },
      "& a": {
        color: "inherit",
        textDecoration: "none",
        fontSize: 14,
        fontWeight: 400,
        lineHeight: "16px",
        padding: 6,
        "&:hover": {
          color: "#f26728",
        },
      },
    },
    [theme.breakpoints.up("md")]: {
      flex: 2,
    },
  },
  contact: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 40px",
    gap: 24,
    "& a": {
      color: "white",
      textDecoration: "none",
      border: `2px solid white`,
      borderRadius: 24,
      padding: "6px 16px",
      fontSize: 16,
      fontWeight: 600,
      transition: "all 0.2s",
      whiteSpace: "nowrap",
      "&:hover": {
        backgroundColor: "white",
        color: "#f26728",
      },
    },
    [theme.breakpoints.up("md")]: {
      flexDirection: "row-reverse",
      gap: 16,
    },
  },
  copyright: {
    textAlign: "center",
    color: "white",
    fontSize: 14,
    fontWeight: 500,
    marginTop: 24,
    [theme.breakpoints.up("md")]: {
      marginTop: 0,
    },
  },
  disclaimer: {
    color: "white",
    fontSize: 12,
    fontWeight: 300,
    padding: "16px 20px",
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      maxWidth: 1024,
      margin: "0 auto",
    },
  },
}));

const Separator = ({ width }) => {
  const StyledSeparator = styled("span")({
    backgroundColor: "white",
    height: 3,
    borderRadius: 8,
    width: width,
  });

  return <StyledSeparator />;
};

const Footer: FC = () => {
  const classes = useStyles();

  const date = new Date();
  const year = date.getFullYear();

  return (
    <footer className={classes.footer}>
      <div className={classes.social}>
        <span>Acompanhe nas redes</span>

        {SOCIAL_MEDIAS.map(({ icon, url }) => (
          <a key={url} href={url} target="_blank">
            <i className={icon}></i>
          </a>
        ))}
      </div>

      <section>
        <div className={classes.logo}>
          <img src={Logo} alt="logo-mercatorio" />
        </div>

        <div className={classes.sections}>
          {SECTIONS.map(({ title, links }) => (
            <div key={title}>
              <p>{title}</p>

              <section>
                <Separator width="12px" />
                <Separator width="24px" />
              </section>

              {links.map(({ label, url }) => (
                <a key={label} href={url} target="_blank">
                  {label}
                </a>
              ))}
            </div>
          ))}
        </div>
      </section>

      <div className={classes.contact}>
        <a href="https://wa.me/553185471112" target="_blank">
          Entre em contato
        </a>
        <Separator width="100%" />
      </div>

      <p className={classes.copyright}>© 2016 - {year} Mercatório</p>

      <p className={classes.disclaimer}>
        A Mercatório informa que a negociação de precatórios não constitui
        oferta de valor mobiliário e, portanto, não é regulada pela CVM. A
        rentabilidade esperada advém única e exclusivamente do reajuste definido
        em lei (IPCA e/ou Selic - conforme o caso) aplicado sobre o valor de
        compra com deságio. Não garantimos a precisão das informações nem a
        rentabilidade apresentada no site, para maiores detalhes, necessário
        acessar as informações de cada precatório. As decisões de investimento
        são de exclusiva responsabilidade do investidor, que deve estar ciente
        dos riscos e possíveis perdas. Recomenda-se a consulta a especialistas
        para avaliar os riscos e a adequação ao perfil de investimento.
      </p>
    </footer>
  );
};

export default Footer;
